import { createApp } from "vue";

import voice from "./components/pages/voice.vue";

createApp(voice, { courses: ["business"] }).mount("#vue-app");
